// extracted by mini-css-extract-plugin
export default {"wrapper":"Weight_wrapper__0GsPT","list":"Weight_list__5U3Pa","row":"Weight_row__mgyJ1","input":"Weight_input__hzBc5","textarea":"Weight_textarea__Dbbhy"};